import { policyEntityReadPermission } from '@backstage-community/plugin-rbac-common';
import { InfoCard } from '@backstage/core-components';
import { useTranslationRef } from '@backstage/frontend-plugin-api';
import { Container } from '@backstage/ui';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { Typography } from '@material-ui/core';
import type { ReactNode } from 'react';
import { accessTranslationRef } from '../translation';
import { AccessPageIntro } from './AccessPageIntro';

const RbacDenied = () => {
  const { t } = useTranslationRef(accessTranslationRef);

  return (
    <Container>
      <InfoCard title={t('page.rbacDeniedTitle')}>
        <Typography>{t('page.rbacDeniedDescription')}</Typography>
      </InfoCard>
    </Container>
  );
};

export const AccessRbacPage = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslationRef(accessTranslationRef);

  return (
    <RequirePermission
      permission={policyEntityReadPermission}
      resourceRef="role:default/adp-permissions"
      errorPage={<RbacDenied />}
    >
      <>
        <Container>
          <AccessPageIntro>{t('page.rbacDescription')}</AccessPageIntro>
        </Container>
        {children}
      </>
    </RequirePermission>
  );
};
